import React from "react";

import { MaterialUIDatePickers } from "./../../stories/hook-controls/datepicker/datepicker";

import { useForm, FormProvider } from "react-hook-form";

export default function App() {
  const methods = useForm();
  return (
    <FormProvider {...methods}>
      <MaterialUIDatePickers name="date" />
    </FormProvider>
  );
}
// const Login = (props) => {
//     const { authState, authActions } = React.useContext(AuthContext);

//     const login = () => {
//       authActions.authStateChanged({ name: "Burhanuddin" });

//     }
//     const Add = () => {
//         authActions.countStateChanged();

//       }

//     return (
//       <div>
//       {console.log(authState.user&&authState.user.name)}
//         {authState.user&&authState.user.name}
//         <button onClick={() => login()}>
//           Login
//         </button>
//         <button onClick={() => Add()}>
//           +
//         </button>
//         {authState.count}
//       </div>
//     );
// };
